"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledToggleButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Button = _interopRequireDefault(require("../Button"));
var _AbstractToggler = require("../AbstractToggler");
var _FilterLabel = _interopRequireDefault(require("../FilterLabel"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MultipleChoiceFilter = function MultipleChoiceFilter(_ref) {
  var items = _ref.items,
    onChange = _ref.onChange,
    _ref$visibleItems = _ref.visibleItems,
    visibleItems = _ref$visibleItems === void 0 ? Infinity : _ref$visibleItems,
    _ref$expandLabel = _ref.expandLabel,
    expandLabel = _ref$expandLabel === void 0 ? 'Показать все' : _ref$expandLabel,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$LabelComponent = _ref.LabelComponent,
    LabelComponent = _ref$LabelComponent === void 0 ? _FilterLabel["default"] : _ref$LabelComponent,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$mobileCheckboxFl = _ref.mobileCheckboxFloat,
    mobileCheckboxFloat = _ref$mobileCheckboxFl === void 0 ? 'right' : _ref$mobileCheckboxFl,
    customCheckboxStyles = _ref.customCheckboxStyles,
    currencyCode = _ref.currencyCode;
  var showToggle = items.length > visibleItems;
  var _useState = (0, _react.useState)(Math.min(items.length, visibleItems)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    itemsToShow = _useState2[0],
    setItemsToShow = _useState2[1];
  (0, _react.useEffect)(function () {
    if (items.length > itemsToShow) {
      setItemsToShow(Math.min(items.length, visibleItems));
    } else {
      setItemsToShow(items.length);
    }
  }, [items]);
  var isClamped = itemsToShow < items.length;
  return /*#__PURE__*/_react["default"].createElement(StyledMultipleChoiceFilter, {
    className: className,
    isMobile: isMobile,
    mobileCheckboxFloat: mobileCheckboxFloat,
    customCheckboxStyles: customCheckboxStyles
  }, items.slice(0, itemsToShow).map(function (item) {
    var id = item.id,
      path = item.path,
      selected = item.selected,
      disabled = item.disabled,
      hotel_count = item.hotel_count,
      min_price = item.min_price,
      suitable_flights = item.suitable_flights;
    var count = hotel_count || suitable_flights;
    return /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
      key: "".concat(path || 'filter', "-").concat(id),
      id: id,
      checked: selected,
      disabled: disabled,
      onClick: function onClick() {
        return onChange(_objectSpread(_objectSpread({}, item), {}, {
          selected: !selected
        }));
      }
    }, /*#__PURE__*/_react["default"].createElement(LabelComponent, (0, _extends2["default"])({}, item, {
      disabled: disabled,
      isMobile: isMobile,
      count: count,
      price: min_price,
      currencyCode: currencyCode
    })));
  }), showToggle && /*#__PURE__*/_react["default"].createElement(StyledToggleButton, {
    onClick: function onClick() {
      return setItemsToShow(isClamped ? items.length : visibleItems);
    },
    isMobile: isMobile
  }, isClamped ? expandLabel : 'Скрыть', /*#__PURE__*/_react["default"].createElement(_AbstractToggler.StyledToggleIcon, {
    isOpen: !isClamped
  })));
};
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).attrs({
  options: {
    enableUncheckOnDisabled: true
  }
}).withConfig({
  displayName: "MultipleChoiceFilter__StyledCheckbox",
  componentId: "sc-1bll8zo-0"
})(["margin-bottom:7px;", ""], function (props) {
  return props.disabled && "\n      &:after {\n        border: 1px dashed #919499;\n      }\n  ";
});
var StyledToggleButton = exports.StyledToggleButton = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "MultipleChoiceFilter__StyledToggleButton",
  componentId: "sc-1bll8zo-1"
})(["font-size:", ";color:", ";", ";"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '16px' : '12px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && 'margin: 15px 0 15px 10px;';
});
var StyledMultipleChoiceFilter = _styledComponents["default"].div.withConfig({
  displayName: "MultipleChoiceFilter__StyledMultipleChoiceFilter",
  componentId: "sc-1bll8zo-2"
})(["", "{", "}"], StyledCheckbox, function (_ref5) {
  var isMobile = _ref5.isMobile,
    mobileCheckboxFloat = _ref5.mobileCheckboxFloat,
    customCheckboxStyles = _ref5.customCheckboxStyles;
  return isMobile && (0, _styledComponents.css)(["flex-direction:", ";align-items:center;margin:0;padding:10px;border-bottom:1px solid #dcdfe4;&:first-child{border-top:1px solid #dcdfe4;}", " ", "{", ";}input[type='checkbox']{width:24px;height:24px;}input[type='checkbox'] + svg{width:16px;height:16px;top:50%;left:50%;transform:translateX(-50%) translateY(calc(-50%));}"], mobileCheckboxFloat === 'right' ? 'row-reverse' : 'row', customCheckboxStyles, StyledCheckbox.StyledWrapper, mobileCheckboxFloat === 'right' ? "margin-right: 0;\n              margin-left: 8px" : "margin-right: 6px;\n              margin-left: 0");
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(MultipleChoiceFilter);